import { combineReducers } from "redux"

//toast
import ToastReducer from "./toast/reducer";

//loader
import LoaderReducer from "./loader/reducer";

import NoticeType from "./noticeType/reducer";

import Depots from "./depots/reducer";

import Users from "./usersManagement/reducer";

import Driver from "./driverManagement/reducer";

import noticeManagement from "./noticeManagement/reducer";



/**
 * Combines multiple reducers into a single root reducer.
 * @param {object} reducers - An object containing the reducers to be combined.
 * @returns The combined root reducer.
 */
const rootReducer = combineReducers({
  ToastReducer,
  LoaderReducer,
  NoticeType,
  Depots,
  Users,
  Driver,
  noticeManagement

})

export default rootReducer
